import { ref, type Ref } from "vue";

export class TimerService {
    private timeSec: Ref<number>;
    private timeMin: Ref<number>;
    private sec: Ref<string>;
    private minute: Ref<string>;
    private isTimerExpired: Ref<boolean>;
    private timerInterval: ReturnType<typeof setTimeout> = setTimeout(() => "", 1000);
    private endTime: number = 0;
    private numSeconds: number = 0;

    constructor() {
        this.timeSec = ref(0);
        this.timeMin = ref(0);
        this.sec = ref("");
        this.minute = ref("");
        this.isTimerExpired = ref(false);        
    }

    public startTimer(numSeconds: number) {    
        this.numSeconds = numSeconds;
        const currentTime = Math.floor(Date.now() / 1000);
        this.endTime = currentTime + numSeconds;
        this.updateTimer(); //let's populate min and sec values as soon as possible
        this.timerInterval = setInterval(this.updateTimer.bind(this), 1000);
    }

    public resetTimer() {
        clearInterval(this.timerInterval);
        this.isTimerExpired.value = false;
        this.startTimer(this.numSeconds);
    }

    private updateTimer() {
        const currentTime = Math.floor(Date.now() / 1000);
        const remainingTime = Math.max(0, this.endTime - currentTime);

        this.timeMin.value = Math.floor(remainingTime / 60);
        this.timeSec.value = remainingTime % 60;

        this.minute.value = this.convert(this.timeMin.value);
        this.sec.value = this.convert(this.timeSec.value);

        if (remainingTime === 0) {
            clearInterval(this.timerInterval);
            this.isTimerExpired.value = true;
        }
    }

    private convert(number: number): string {
        return number < 10 ? "0" + number.toString() : number.toString();
    }

    public getMinute(): Ref<string> {
        return this.minute;
    }

    public getSec(): Ref<string> {
        return this.sec;
    }

    public getIsTimerExpired(): Ref<boolean> {
        return this.isTimerExpired;
    }
}
